import * as components from "./components";
import * as routes from "./routes";

export { components, routes };
